// extracted by mini-css-extract-plugin
module.exports = {"melodyVideo":"Na","landingPageVideo":"Oa","play":"Pa","iframeVideo":"Qa","playHidden":"Ra","fullwidth":"Sa"};